<template>
  <div class="privacy-container viewport">
    <div class="close-button">
      <div class="close" @click="closeOverlay()">
        {{ $t("age_check.back") }}
      </div>
    </div>
    <div>
      <En v-if="country === 'en'" />
      <De v-else-if="country === 'de'" />
      <En v-else />
    </div>
  </div>
</template>

<script>
import En from "@/components/terms/En";
import De from "@/components/terms/De";
export default {
  components: { En, De },
  computed: {
    termsOverlayOpen() {
      return this.$store.state.termsOverlay;
    },
    country() {
      return this.$store.state.country;
    },
  },
  methods: {
    closeOverlay() {
      this.$store.commit("setScrollDisabled", true);
      this.$store.commit("setTermsOverlay", false);
    },
  },
};
</script>
<style scoped>
.privacy-container {
  overflow: auto;
  z-index: 301;
  width: 100%;
  padding: 30px 10px 0 30px;
  display: flex;
  flex-direction: column;
}

.close-button {
  margin-right: 30px;
  font-size: 20px;
}

.close {
  font-size: 16px;
  font-weight: bold;
  border: 2px solid #db6b30;
  display: inline-block;
  padding: 1.25rem 2.5rem;
  border-radius: 1rem;
  color: #db6b30;
  margin-bottom: 1.5rem;
  cursor: pointer;
  background-color: transparent;
}
</style>
